import React, { useRef, useState, forwardRef } from "react";

const ScrollComponent = forwardRef((props, ref) => {
    const {direction} = props
    const scrollRef = useRef();
    const raf = useRef();
    const velocity = useRef();
    const [start, setStart] = useState(0);
    const [offset, setOffset] = useState(0);
    const [pointer, setPointer] = useState(false);

    React.useImperativeHandle(ref, () => ({
        scrollTo: (options) => {
            scrollRef.current?.scrollTo(options);
        },
        scrollLeft: scrollRef.current?.scrollLeft,
        scrollTop: scrollRef.current?.scrollTop,
        querySelector: (selector) => scrollRef.current?.querySelector(selector),
        querySelectorAll: (selector) => scrollRef.current?.querySelectorAll(selector)
    }));
    const handleScroll = (e) => {
        e.stopPropagation();
        if (props.lockWheel) return
        direction == "horizontal" ? scrollRef.current.scrollLeft += e.deltaY : scrollRef.current.scrollTop += e.deltaY;
    };

    const handlePointerDown = (e) => {
        setStart((direction == "horizontal" ? e.pageX : e.pageY) - (direction == "horizontal" ? scrollRef.current.offsetLeft : scrollRef.current.offsetTop))
        setOffset(direction == "horizontal" ? scrollRef.current.scrollLeft : scrollRef.current.scrollTop)
        cancelAnimationFrame(raf.current)
    }

    const handlePointerMove = (e) => {
        e.stopPropagation();
        if (e.buttons != 1 || e.pointerType == 'touch') return
        setPointer(true)
        calculateMove({
            pos: direction == "horizontal" ? e.pageX : e.pageY,
            offset: direction == "horizontal" ? scrollRef.current.offsetLeft : scrollRef.current.offsetTop
        })
    }
    const handlePointerUp = (e) => {
        setPointer(false)
        raf.current = requestAnimationFrame(inertiaLoop)
    }

    const calculateMove = (e) => {
        const x = e.pos - e.offset
        const prevScroll = direction == "horizontal" ? scrollRef.current.scrollLeft : scrollRef.current.scrollTop
        direction == "horizontal" ? scrollRef.current.scrollLeft = offset - (x - start) : scrollRef.current.scrollTop = offset - (x - start)
        velocity.current = (direction == "horizontal" ? scrollRef.current.scrollLeft : scrollRef.current.scrollTop) - prevScroll
    }

    const inertiaLoop = () => {
        if (!scrollRef.current) return
        direction == "horizontal" ? scrollRef.current.scrollLeft += velocity.current : scrollRef.current.scrollTop += velocity.current
        velocity.current *= 0.98
        if (Math.abs(velocity.current) > 0.5) raf.current = requestAnimationFrame(inertiaLoop)
    }

    return (
        <div
            ref={scrollRef}
            onWheel={handleScroll}
            onPointerDown={handlePointerDown}
            onPointerUp={handlePointerUp}
            onPointerMove={handlePointerMove}
            className={[`${props.className} ${pointer ? 'scrolling' : ''}`]}
        >
            {props.children}
        </div>
    );
});

export default ScrollComponent;
